import { render, staticRenderFns } from "./SenAnswer.vue?vue&type=template&id=eb6f2dc8&scoped=true&"
import script from "./SenAnswer.vue?vue&type=script&lang=js&"
export * from "./SenAnswer.vue?vue&type=script&lang=js&"
import style0 from "./SenAnswer.vue?vue&type=style&index=0&id=eb6f2dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6f2dc8",
  null
  
)

export default component.exports